import { ViewModel, View, ObservableArray } from "binder"
import { ToolValidStatusEditorView } from "./toolValidStatusEditor-view"
import { IToolValidStatus } from "../IToolValidStatus";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";
import { ToolStatusMultiSelectorViewModel } from "../toolStatusMultiSelector";
import { ToolStatusesViewModel } from "../toolValidStatusManipulation-viewModel";

export class ToolValidStatusEditorViewModel extends ViewModel implements IToolValidStatus, IPopup {
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.toolStatusSelector = new ToolStatusMultiSelectorViewModel(this);
    }
    GetDefaultView(): View<ViewModel> {
        return new ToolValidStatusEditorView();
    }
    public getTypeId(): string {
        return "VM-3CAC9490-6D94-4670-8A63-82064EAEDD04"
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set toolTypeName(v: string) { this._toolTypeName = v; } public get toolTypeName(): string { return this._toolTypeName; } private _toolTypeName: string;
    public set toolModelId(v: string) { this._toolModelId = v; } public get toolModelId(): string { return this._toolModelId; } private _toolModelId: string;
    public set toolModelName(v: string) { this._toolModelName = v; } public get toolModelName(): string { return this._toolModelName; } private _toolModelName: string;
    public set toolModelCode(v: string) { this._toolModelCode = v; } public get toolModelCode(): string { return this._toolModelCode; } private _toolModelCode: string;
    public set toolStatusSelector(v: ToolStatusMultiSelectorViewModel) { this._toolStatusSelector = v; } public get toolStatusSelector(): ToolStatusMultiSelectorViewModel { return this._toolStatusSelector; } private _toolStatusSelector: ToolStatusMultiSelectorViewModel;
    public set toolStausIds(v: ObservableArray<ToolStatusesViewModel>) { this._toolStausIds = v; } public get toolStausIds(): ObservableArray<ToolStatusesViewModel> { return this._toolStausIds; } private _toolStausIds: ObservableArray<ToolStatusesViewModel>;

    setToolStatusListIds(value: string[]) {
        this.toolStatusSelector.selectById(value);
    }
    getToolStatusListIds(): string[] {
        return this.toolStatusSelector.selectedItems.map(item => item.id);
    }

    setToolStatusIds(value: string[]) {
        throw new Error("Method not implemented.");
    }
    getToolStatusIds(): string[] {
        return this.toolStausIds.map(q => q.id);
    }

    closePopup(result?: any) {

    }

    async cloneTo(toolValidStatus: IToolValidStatus) {
        toolValidStatus.id = this.id;
        toolValidStatus.toolTypeName = this.toolTypeName;
        toolValidStatus.toolModelId = this.toolModelId;
        toolValidStatus.toolModelName = this.toolModelName;
        toolValidStatus.toolModelCode = this.toolModelCode;
        toolValidStatus.setToolStatusIds(this.getToolStatusIds());
        toolValidStatus.setToolStatusListIds(this.getToolStatusListIds());
    }

    back() {
        this.closePopup(null);
    }

    async save() {
        let verificationResult = this.verify();
        if (verificationResult.length > 0) {
            this.messageBoxConfirmWarning(verificationResult.join('\n'), 'خطا در ثبت وضعیت ابزار');
            return;
        } else {
            try {
                this.isLoading = true;
                let result = await ServerConnection.callServer('/Complex/ToolStatusServices/UpdateToolModelStatuses', {
                    ToolModelId: this.toolModelId,
                    StatusListIds: this.getToolStatusListIds(),
                });
                if (result.IsSuccessful == false) {
                    if (result.Faults[0].Parameters.FaultId == '234FBD2B-3143-46A8-AA06-9EAF90B174AF') {
                        let result = await ServerConnection.callServer('/Complex/ToolStatusServices/ListActiveToolStatuses', {
                            ToolModel: this.toolModelId,
                            ToolValidStatuses: this.toolStausIds
                        });
                        result.SingleTools.map(item => item.name);
                        await this.messageBoxConfirmWarning('اطلاعات به اشتباه وارد شده است.', 'خطا در عملیات');
                    }
                }
                else {
                    await this.messageBoxConfirmSuccess('وضعیت ابزار با موفقیت ثبت شد.', 'ثبت موفق');
                    this.closePopup('done');
                }
            } catch (ex) {
                console.log(ex);
                await this.messageBoxConfirmWarning("خطا در ثبت وضعیت ابزار", "خطا در عملیات");
            } finally {
                this.isLoading = false;
            }
        }
    }

    verify(): string[] {
        let result: string[] = [];
        if (stringIsNullOrEmpty(this.toolStatusSelector.selectedItems.map(item => item.name).toString())) {
            result.push('وضعیت ابزار مشخص نشده است.');
        }
        return result;
    }
}
